// extracted by mini-css-extract-plugin
module.exports = {"container":"_9l7GEG9tsGCdkgCET_ltJ","item":"_1RdJNor1eYRHE4sKDH8UxN","dot":"YxIn5XVlpnPOfi2P08MLP"};